import type { Components } from 'react-markdown'

export const carbonMarkdownToHtml: Components = {
  p: (props) => (
    <p className="text-[14px] leading-[1.62] text-cb-text [&+*]:mt-3" {...props} />
  ),
  strong: (props) => <strong className="font-bold text-cb-text" {...props} />,
  em: (props) => <em className="italic" {...props} />,
  a: (props) => (
    <a
      className="text-cb-accent underline underline-offset-2"
      target="_blank"
      rel="noreferrer"
      {...props}
    />
  ),
  ul: (props) => (
    <ul className="flex list-none flex-col gap-2.5 p-0 [&+*]:mt-3" {...props} />
  ),
  ol: (props) => (
    <ol
      className="flex list-decimal flex-col gap-2.5 pl-5 [&+*]:mt-3"
      {...props}
    />
  ),
  li: (props) => (
    <li className="text-[14px] leading-[1.55] text-cb-text-2" {...props} />
  ),
  code: (props) => (
    <code
      className="rounded-[5px] border border-cb-chip-border bg-cb-chip-bg px-1.5 py-px font-cb-mono text-[12px] leading-[1.5] text-cb-chip-text"
      {...props}
    />
  ),
  pre: (props) => (
    <pre
      className="overflow-x-auto rounded-[10px] border border-cb-border bg-cb-panel-2 p-3 font-cb-mono text-[12.5px] text-cb-text [&_code]:border-0 [&_code]:bg-transparent [&_code]:p-0 [&_code]:text-cb-text"
      {...props}
    />
  ),
  h1: (props) => (
    <h3 className="text-[15px] font-bold text-cb-text [&+*]:mt-2" {...props} />
  ),
  h2: (props) => (
    <h3 className="text-[15px] font-bold text-cb-text [&+*]:mt-2" {...props} />
  ),
  h3: (props) => (
    <h3 className="text-[14px] font-bold text-cb-text [&+*]:mt-2" {...props} />
  ),
  blockquote: (props) => (
    <blockquote
      className="border-l-2 border-cb-accent-line pl-3 text-[13.5px] italic text-cb-text-2"
      {...props}
    />
  ),
}
